import { ChakraProvider } from '@chakra-ui/react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'

import store from '@core/app/store/store'

import '../../index.css'
import { PageUnknown } from './Unknown'
import theme from '../../theme'

import '@core/utils/i18n'

const app = document.getElementById('root')
const root = createRoot(app!)
root.render(
    <>
        <Provider store={store}>
            <ChakraProvider theme={theme}>
                <PageUnknown />
            </ChakraProvider>
        </Provider>
    </>
)
